import React from "react";

export default function Tag(props) {
  return (
    <div>
      <div className="recipe-card-tag font-worksans text-zinc-800">Cake</div>
    </div>
  );
}
